'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = require('./internal/util');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * note -> markup output to page
 <iframe src="/forms/paymetric-cc-field"
 frameborder="0"
 scrolling="no"
 id="paymetricIframe"
 name="paymetricIframe"
 class="payment-cc-frame"></iframe>

 <input type="hidden" id="AccessToken" name="AccessToken" value="{ACCESS_TOKEN}"/>
 */

// default config options for Paymetric
var DEFAULT_SETTINGS = {
    // data: null,
    placeholderId: 'paymetric-cc-container',
    accessToken: null,
    xiInterceptURL: null,
    xiInterceptGUID: null,
    xiIFrameJS: null,
    autosizeheight: true,
    autosizewidth: false,
    catchTimeout: true

    // onReceive: null,
    // onReply: null,
    // onSuccess: null,
    // onLoadSuccess: null,
    // onError: null,
    // onCardTypeChange: null,
    // onValidate: null,
    // onInvalidHandler: null,
    // amount: -1,
    // intcp3DSecure: null
};

var IFRAME_ONLOAD_DELAY = 100;
var IFRAME_TIMEOUT = 5000;

var PaymetricIFrame = function () {
    function PaymetricIFrame(settings) {
        _classCallCheck(this, PaymetricIFrame);

        this.iframeHasLoaded = false;
        this.configure(settings);
        return this;
    }

    _createClass(PaymetricIFrame, [{
        key: 'configure',
        value: function configure() {
            var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = _extends({}, DEFAULT_SETTINGS, this.settings, settings);

            return this;
        }
    }, {
        key: 'updateAccessToken',
        value: function updateAccessToken(accessToken) {
            var settings = this.configure({ accessToken: accessToken });
            console.warn('[Paymetric] configuration updated', settings);

            // if iframe has already loaded, reload with new token info
            if (this.iframeHasLoaded) {
                this._renderIframe();
            }
        }
    }, {
        key: '_loadXIFrameLib',
        value: function _loadXIFrameLib() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = this.settings.xiIFrameJS;
            var head = document.getElementsByTagName('head')[0];
            head.appendChild(s);

            return new Promise(function (resolve, reject) {
                s.onload = function () {
                    return resolve();
                };
                setTimeout(function () {
                    return reject('TimeoutError: Paymetric library failed to load');
                }, 10000);
            });
        }
    }, {
        key: 'loadIframe',
        value: function loadIframe(listeners) {
            var _this = this;

            var accessToken = this.settings.accessToken;

            this.onLoadListeners = listeners;
            if (!accessToken) {
                throw ReferenceError('[Paymetric] AccessToken is not defined');
            }

            return this._loadXIFrameLib().then(function () {
                return _this._renderIframe();
            });
        }
    }, {
        key: '_renderIframe',
        value: function _renderIframe() {
            var _this2 = this;

            var _settings = this.settings,
                xiInterceptURL = _settings.xiInterceptURL,
                xiInterceptGUID = _settings.xiInterceptGUID,
                accessToken = _settings.accessToken;

            this.iframe = (0, _util.createIframe)(xiInterceptURL, xiInterceptGUID, accessToken);
            this.hiddenInput = (0, _util.createHiddenInput)(accessToken);
            this.container = document.getElementById(this.settings.placeholderId);

            if (!this.container) {
                throw Error('iframe placeholder with id "' + this.settings.placeholderId + '" is missing');
            }

            var renderPromise = new Promise(function (resolve, reject) {
                if (_this2.iframe) {
                    var onload = function onload() {
                        console.log('[Paymetric] iframe loaded');
                        setTimeout(function () {
                            // note -> this is wrapped in a timeout to get around an bug (affecting Android only) that prevents
                            //  the $XIFrame[onLoadSuccess] handler from ever firing as if there is a race condition within $XIFrame.load
                            $XIFrame.onload(_extends({
                                iFrameId: _this2.iframe.id,
                                targetUrl: _this2.iframe.getAttribute('src'),
                                onLoadSuccess: function onLoadSuccess(e) {
                                    console.log('[Paymetric] onLoadSuccess');
                                    _this2.iframeHasLoaded = true;
                                    renderPromise.done = true;
                                    console.warn('[PaymetricLoad] Success: ' + _this2.iframe.getAttribute('src') + ', ' + JSON.stringify(e));
                                    resolve(e);
                                },
                                onError: function onError(err) {
                                    renderPromise.rejected = true;
                                    console.error('[PaymetricLoadError]: ' + err);
                                    reject(err);
                                }
                            }, (0, _util.applyListeners)(_this2.onLoadListeners)));
                        }, IFRAME_ONLOAD_DELAY);
                    };
                    _this2.iframe.addEventListener('load', onload, false);

                    // remove contents
                    while (_this2.container.lastChild) {
                        _this2.container.removeChild(_this2.container.lastChild);
                    }

                    _this2.container.appendChild(_this2.hiddenInput);
                    _this2.container.appendChild(_this2.iframe);

                    // reject onLoad handler if it takes to long to load
                    if (_this2.settings.catchTimeout) {
                        setTimeout(function () {
                            if (!renderPromise.done || !renderPromise.rejected) {
                                reject('Iframe timeout');
                            }
                        }, IFRAME_TIMEOUT);
                    }
                }
            });

            return renderPromise;
        }
    }, {
        key: 'submitIframe',
        value: function submitIframe(listeners) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                if (_this3.iframe) {
                    $XIFrame.submit(_extends({
                        iFrameId: _this3.iframe.id,
                        targetUrl: _this3.iframe.getAttribute('src'),
                        onSuccess: function onSuccess(msg) {
                            try {
                                var message = JSON.parse(msg);
                                if (message.data.HasPassed) {
                                    resolve(message && message.data.HasPassed);
                                } else {
                                    reject(message.data.Message);
                                }
                            } catch (err) {
                                reject(err);
                            }
                        },
                        onError: function onError(err) {
                            reject(err);
                        }
                    }, (0, _util.applyListeners)(listeners, resolve, reject)));
                } else {
                    reject('[ReferenceError] Paymetric iframe is undefined');
                }
            });
        }
    }]);

    return PaymetricIFrame;
}();

exports.default = PaymetricIFrame;